import React from 'react'
import { Box, Text } from '@chakra-ui/react'
import { PaymentMethodUnused } from './PaymentMethodUnused'
import { PaymentMethodUsed } from './PaymentMethodUsed'

export const PaymentMethodDisplay = ({ cardLast4, cardNumberMasked, hasUsedCard = false, onChangePaymentMethod, onChangeCard }) => (
  <Box>
    {/* セクションタイトル */}
    <Text fontSize="md" fontWeight="600" color="label.primary" lineHeight="22px" mb="8px">
      決済手段
    </Text>

    {/* カード情報ボックス */}
    <Box bg="white" borderRadius="4px" border="1px solid" borderColor="divider.light" px="16px" py="16px">
      {/* パターン1: カード未使用（初回購入） */}
      {!hasUsedCard && cardLast4 && <PaymentMethodUnused cardLast4={cardLast4} onChangePaymentMethod={onChangePaymentMethod} />}

      {/* パターン2: カード使用済み（2回目以降） */}
      {hasUsedCard && cardNumberMasked && <PaymentMethodUsed cardNumberMasked={cardNumberMasked} onChangeCard={onChangeCard} />}
    </Box>
  </Box>
)
